// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@sc/App/SharedStyles/CartLineSharedStyles";
import { savedOrderDetailsCartLineStyles } from "@sc/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

savedOrderDetailsCartLineStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

savedOrderDetailsCartLineStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

savedOrderDetailsCartLineStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

savedOrderDetailsCartLineStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

savedOrderDetailsCartLineStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

savedOrderDetailsCartLineStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

savedOrderDetailsCartLineStyles.noPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        text: {
            ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text,
            color: "primary.main",
        },
    },
};
